
import { computed, defineComponent, PropType } from 'vue';
import { useRoute } from 'vue-router';
import { useDriveStore } from '@/modules/drive/store/driveStore';
import { useMainStore } from '@/store/mainStore';
import { MEDIA_TYPES, SHARE_SETTINGS } from '@/types/enums';

export default defineComponent({
  props: {
    currentType: { type: String as PropType<MEDIA_TYPES>, required: true },
  },
  setup(props) {
    const route = useRoute();
    const driveStore = useDriveStore();
    const mainStore = useMainStore();

    const showEdit = computed(() => props.currentType === MEDIA_TYPES.PHOTO);
    const isNetwork = computed(() => route.meta.isNetwork || false);
    const isMy = computed(() => driveStore.appPhotoViewMedia?.owner?.accountId === mainStore.user.accountId
                                    || driveStore.appPhotoViewMedia?.owner?.accountId === mainStore.boundCorporate.internalId);

    const toShare = computed(() => (!isNetwork.value && isMy.value)
      || (driveStore.appPhotoViewMedia?.root && driveStore.appPhotoViewMedia?.shareSettings?.includes(SHARE_SETTINGS.RESHARE_ALLOWED)));

    return {
      showEdit,
      isNetwork,
      isMy,
      toShare,
    };
  },
});
